import React, { useEffect, useState } from "react";
import DateInput from "../sharedComponents/datesInputs/date";
import TextInput from "../sharedComponents/inputs/textInput";
import Titlebar from "../layout/titlebar";
import Lang from "../../userPreferences/staticWords";
import {
  getAgendaAPI,
  getAllAgendaAPI,
} from "../../API/store/actions/agendaAndLinks";
import { useDispatch, useSelector } from "react-redux";
import { getAllAgenda } from "../../API/services/agendaAndLinks";
import { paths } from "../../paths/paths";

const AgendaList = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);
  const formatDateOnly = (date) => {
    if (!date) return undefined;

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const load = async () => {
      setLoading(true);

      try {
        const payload = {
          active: true,
          startDate: formatDateOnly(startDate),
          endDate: formatDateOnly(endDate),
        };

        const action = await getAllAgendaAPI(payload, userToken);
        dispatch(action);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [userToken, dispatch, startDate, endDate]);
  const agendas = useSelector((state) => state.agenda.agenda);
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date)) return "";

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  return (
    <div className="d-flex flex-column col-xl-7 col-12 px-5">
      <div className="d-flex align-items-center">
        <img src="/assets/images/calender.svg" width={25} height={25} alt="" />
        <p className="mt-3 px-2" style={{ fontSize: 25 }}>
          أجندة الفعاليات
        </p>
      </div>
      <div
        className="row mb-4 p-3"
        style={{
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
        }}
      >
        <div className="col-md-3">
          <label className="mb-2">من</label>
          <DateInput value={startDate} onChange={setStartDate} isClearable />
        </div>
        <div className="col-md-3">
          <label className="mb-2">إلى</label>
          <DateInput value={endDate} onChange={setEndDate} isClearable />
        </div>
      </div>

      <div className="d-flex row gap-y-5">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">...جاري التحميل</span>
            </div>
          </div>
        ) : agendas?.length === 0 ? (
          <div
            className="w-100 text-center py-5"
            style={{
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            }}
          >
            <h5 className="text-muted  mb-2">لا توجد فعاليات متاحة</h5>

            {/* <p className="text-muted mb-0">
              لا توجد فعاليات مطابقة للفترة المحددة.
            </p> */}
          </div>
        ) : (
          agendas.map((item) => (
            <div
              key={item.id}
              className="mb-4"
              style={{
                borderRadius: 16,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                backgroundColor: "#fff",
                padding: 0,
              }}
            >
              <div className="d-flex flex-column align-items-start p-4">
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#4D4D4D",
                  }}
                >
                  {item.title}
                </div>

                <div
                  style={{
                    fontSize: 20,
                    color: "#8C8C8C",
                  }}
                >
                  تاريخ السجل {formatDate(item.registerDate)}
                </div>
              </div>

              <div
                className="d-flex justify-content-between align-items-center px-4 py-3"
                style={{
                  backgroundColor: "#F2F2F2",
                }}
              >
                {item?.attachment ? (
                  <>
                    <div
                      style={{
                        fontSize: 18,
                        color: "#666",
                      }}
                    >
                      الملف المرفق :
                      <span className="px-3">{item.attachment}</span>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                      <a
                        download
                        href={`${paths.Agenda}${item.id}/${item.attachment}`}
                        className="text-black text-decoration-none d-flex align-items-center gap-3"
                        rel="noreferrer"
                      >
                        <span
                          style={{
                            fontSize: 18,
                            cursor: "pointer",
                            margin: "0 10px",
                          }}
                        >
                          تنزيل الملف
                        </span>

                        <img
                          src="/assets/images/greenDownlaod.svg"
                          width={25}
                          height={25}
                          alt=""
                        />
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="w-100"></div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AgendaList;
